import { jsx as _jsx } from "react/jsx-runtime";
import { useObjectId } from '../v2/hooks/useObjectId';
import PipelineButton from './pipeline/components/PipelineButton';
import PipelineSelect from './pipeline/components/PipelineSelect';

const PropertyInputPipelineV2 = props => {
  const objectId = useObjectId();

  if (!objectId) {
    return /*#__PURE__*/_jsx(PipelineSelect, Object.assign({}, props));
  }

  return /*#__PURE__*/_jsx(PipelineButton, Object.assign({}, props));
};

PropertyInputPipelineV2.displayName = 'PropertyInputPipelineV2';
export default PropertyInputPipelineV2;